import { updateProjectDescription } from "@/api/projects";
import { useState } from "react";


export function SaveButton({ setIsEditing, project_id, setCurrentText, current_text }: { setIsEditing: (isEditing: boolean) => void; project_id: string; setCurrentText: (text: string) => void; current_text: string; }) {
    const [error, setError] = useState(false);
    const [processing, setProcessing] = useState(false);
    const handleClick = async () => {
        setProcessing(true);
        setCurrentText(current_text);

        const status_code = await updateProjectDescription(project_id, current_text);

        if (status_code === 200) {
            setIsEditing(false);
        } else {
            setError(true);
        }
        setProcessing(false);
    };
    return (
        <>
            <button onClick={handleClick} className="bg-blue-500 text-white p-2 rounded-md">Save</button>
            {processing && <p className="text-blue-500">Processing...</p>}
            {error && <p className="text-red-500">Error updating project description</p>}
        </>
    );
}
